import { createContext, useContext } from "react";

export const AdGroupSelectionContext = createContext(null);
export const AdSelectionContext = createContext(null);

export const useRequiredAdGroupSelection = () => {
  const selection = useContext(AdGroupSelectionContext);
  if (!selection) {
    throw new Error(
      "useRequiredAdGroupSelection must be used within AdGroupSelectionGate"
    );
  }
  return selection;
};

export const useRequiredAdSelection = () => {
  const selection = useContext(AdSelectionContext);
  if (!selection) {
    throw new Error(
      "useRequiredAdSelection must be used within AdSelectionGate"
    );
  }
  return selection;
};
